import React, { Suspense } from 'react';
import { Download, Users } from 'lucide-react';

const Spline = React.lazy(() => import('@splinetool/react-spline'));

export const Hero = () => {
  return (
    <section
      id="hero"
      style={{
        background: 'var(--bg-primary)',
        minHeight: '100vh',
        paddingTop: '80px',
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          display: 'flex',
          width: '100%',
          maxWidth: '1400px',
          margin: '0 auto',
          padding: '0 7.6923%',
          gap: '60px',
          alignItems: 'center',
        }}
        className="hero-container"
      >
        {/* Left Content */}
        <div style={{ flex: 1, zIndex: 2 }}>
          <h1
            style={{
              fontSize: '66px',
              fontWeight: 600,
              lineHeight: 1.1,
              letterSpacing: '-0.62px',
              color: 'var(--text-primary)',
              marginBottom: '24px',
            }}
            className="hero-title"
          >
            Otomasi Pesanan inDriver.
            <br />
            <span style={{ color: 'var(--brand-primary)' }}>Hasilkan Lebih Banyak.</span>
            <br />
            Berkendara Lebih Cerdas.
          </h1>
          <p
            style={{
              fontSize: '20px',
              fontWeight: 500,
              lineHeight: 1.5,
              color: 'var(--text-secondary)',
              marginBottom: '40px',
              maxWidth: '600px',
            }}
            className="hero-subtitle"
          >
            BAiBOT inDriver membantu driver otomatis menerima, melewati, dan mengoptimalkan
            permintaan pesanan menggunakan otomasi cerdas.
          </p>
          <div
            style={{
              display: 'flex',
              gap: '16px',
              flexWrap: 'wrap',
            }}
          >
            <a
              href="https://baiclopz.cloud/Baiclopz/apk/baibot.apk"
              className="btn-primary"
              style={{ textDecoration: 'none' }}
            >
              <Download size={20} />
              Download Aplikasi
            </a>
            <a
              href="https://t.me/realbai"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-secondary"
              style={{ textDecoration: 'none' }}
            >
              <Users size={20} />
              Gabung Komunitas
            </a>
          </div>
        </div>

        {/* Right Spline 3D */}
        <div
          style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          className="spline-container"
        >
          <div
            style={{
              width: '700px',
              height: '700px',
              overflow: 'visible',
              position: 'relative',
            }}
          >
            <Suspense
              fallback={
                <div
                  style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'var(--text-muted)',
                  }}
                >
                  Loading 3D...
                </div>
              }
            >
              <Spline scene="https://prod.spline.design/NbVmy6DPLhY-5Lvg/scene.splinecode" />
            </Suspense>
          </div>
        </div>
      </div>

      <style>
        {`
          @media (max-width: 1024px) {
            .hero-container {
              flex-direction: column;
              text-align: center;
            }
            .hero-title {
              font-size: 48px !important;
            }
            .hero-subtitle {
              font-size: 18px !important;
            }
            .spline-container {
              width: 100%;
              max-width: 500px;
              overflow: hidden;
            }
          }
          @media (max-width: 767px) {
            .hero-title {
              font-size: 32px !important;
            }
            .hero-subtitle {
              font-size: 16px !important;
            }
            .spline-container {
              max-width: 100%;
              overflow: hidden;
            }
            .spline-container div {
              width: 100% !important;
              max-width: 390px !important;
              height: 390px !important;
              margin: 0 auto;
            }
          }
        `}
      </style>
    </section>
  );
};